import React from "react";
import { Async } from "react-select";
import axios from "../../../axios";

class SearchUser extends React.Component {
	constructor() {
		super();

		this.state = {
			rsValue: "",
			rsValueUserId: null
		};

		this.onChange = this.onChange.bind(this);
		this.getUsers = this.getUsers.bind(this);
	}

	onChange(rsValue) {
		this.setState({
			rsValue
			// rsValueUserId: rsValue !== null ? rsValue.user_id : null
		});

		if (rsValue !== null) {
			this.props.handleClick(rsValue.user_id);
		}
	}

	getUsers(input) {
		if (!input) {
			return Promise.resolve({ options: [] });
		}

		return axios
			.post(`/user?cari=${input}`)
			.then(response => response.data.data)
			.then(data => {
				return { options: data };
			});
	}

	render() {
		return (
			<div>
				<Async
					multi={false}
					value={this.state.rsValue}
					onChange={this.onChange}
					valueKey="user_id"
					labelKey="user_nama"
					loadOptions={this.getUsers}
					backspaceRemoves
					placeholder="Search"
					searchPromptText="Cari nama siswa, guru, wali, dll.."
					arrowRenderer={() => <i className="fa fa-search text-muted" />}
				/>
			</div>
		);
	}
}

export default SearchUser;



// WEBPACK FOOTER //
// ./src/views/Chat/components/SearchUser.js